import React from 'react'
import { PDFViewer } from '@react-pdf/renderer'
import Generator from './pdfGenerator'
import './index.scss'

const Renderer = () => {
    return (
        <div className="testing">
            <PDFViewer>
              <Generator />
            </PDFViewer>
        </div>  
    )
}

const MemoizedRenderer = React.memo(Renderer)

export default MemoizedRenderer